// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5582) return "static/chunks/5582-96191fabe557a36c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1817":"182fbb577dd7c8fa","3391":"2abc5973576a9e26","4031":"ab55ee28b65d8af7","5259":"557742e348d7bb42","5892":"79625ddd794a67f1","6356":"151e585744263cd3","7516":"ca3bb73bcfecebd6","8543":"757d4151a65888c6","9585":"36f813039575362d","9690":"e530ca5941d0270c"}[chunkId] + ".js";
};